import PaginationMenu from "./pagination-menu";

// ----------------------- "SHOWING X–Y OF N" + PAGES ------------------------------------
export default function ListFooter({ page, total, pageSize, onPageChange }: { page: number; total: number; pageSize: number; onPageChange: (page: number) => void }) {
  if (!total) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  return (
    <div className="mt-4 flex flex-col items-center gap-1">
      <p className="font-[Gilroy-Medium] text-[13px] text-light-gray">
        Showing {from.toLocaleString()}–{to.toLocaleString()} of {total.toLocaleString()}
      </p>
      <PaginationMenu currentPage={page} totalCount={total} pageSize={pageSize} onPageChange={onPageChange} className="!py-2" />
    </div>
  );
}
